import {
  Box,
  Checkbox,
  Grid,
  Slider,
  Typography,
  TextField,
  MenuItem,
  CircularProgress,
  Pagination,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./Requirement.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
} from "../../utils/const";
import TimelineCard from "../../components/containers/TimelineCard";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router-dom";
import MoreFilterInternalResume from "../../components/containers/MoreFilterInternalResume";
import { getJobTimeline } from "../../redux/jobTimeline/jobTimelineSlice";
import { useDispatch, useSelector } from "react-redux";
import SearchRequirement from "../../screens/Requirement/SearchRequirement";
import HotOpningViewDrawer from "./HotOpningViewDrawer";
import { allLocation } from "../../redux/common/locationSlice";
import { allSkill } from "../../redux/common/skillSlice";

const JobSearchResult = () => {
  const [jobTimeline, setJobTimeline] = useState([]);
  const [jobTimelineList, setJobTimelineList] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);

  const [filter, setFilter] = useState({
    jobProfile: "",
    client: "",
    formDate: "",
    toDate: "",
    location: "",
    lowtoHigh: "",
  });

  const [searchData, setSearchData] = useState({
    requirement_type: [],
    visa: [],
    location: [],
    start_date: "",
    end_date: "",
    job_title: [],
  });
  const [hotListRow, setHotListRow] = useState({});
  const [show, setShow] = useState(false);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const jobtimeline = useSelector((state) => state.jobtimeline?.data);
  const skillData = useSelector((state) => state.skill.data);
  const jobtimelineStatus = useSelector((state) => state.jobtimeline?.status);
  const locations = useSelector((state) => state.location);
  const [page, setPages] = useState(jobtimeline?.jobs?.current_page || 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });

  const [data, setData] = useState(
    location.state || JSON.parse(localStorage.getItem("timelineJobDetails"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "timelineJobDetails",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  console.log({ jobtimeline });

  useEffect(() => {
    if (data?.names === "profile_view") {
      handleShow();
      setHotListRow(data?.row?.job_details);

      localStorage.setItem(
        "timelineJobDetails",
        JSON.stringify({ row: data?.row, names: "" })
      );
    }
    if (data?.names === "profile_view_candidate") {
      handleShow();
      setHotListRow(data?.row);

      localStorage.setItem(
        "timelineJobDetails",
        JSON.stringify({ row: data?.row, names: "" })
      );
    }
  }, [data]);

  useEffect(() => {
    dispatch(getJobTimeline());
    dispatch(allLocation());
    dispatch(allSkill());
  }, []);

  useEffect(() => {
    dispatch(getJobTimeline(`page=${page}`));
  }, [page]);

  useEffect(() => {
    setJobTimeline(jobtimeline?.jobs);
    setJobTimelineList(jobtimeline?.jobs);
  }, [jobtimeline]);

  useEffect(() => {
    if (jobTimelineList) {
      const jobTitle = jobTimelineList
        ?.map((requirement) => requirement.job_title)
        .filter(
          (title, index, self) => title && self?.indexOf(title) === index
        ); // Remove duplicates and nulls
      setJobTitles(jobTitle);
    }
  }, [jobTimelineList]);

  useEffect(() => {
    if (jobTimelineList?.jobs) {
      setPagination({
        current_page: jobTimelineList?.jobs?.current_page,
        has_next: jobTimelineList?.jobs?.has_next,
        has_previous: jobTimelineList?.jobs?.has_previous,
        next_page: jobTimelineList?.jobs?.next_page,
        previous_page: jobTimelineList?.jobs?.previous_page,
        total_pages: jobTimelineList?.jobs?.total_pages,
      });
    }
  }, [jobTimelineList?.jobs]);

  const handlePageChange = (event, value) => {
    setPages(value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const handleOnClickSearch = () => {
    // useEffect(() => {
    if (searchData) {
      console.log({ searchData });
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];
        console.log({ value });

        if (Array.isArray(value) && value.length > 0) {
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log("Filtered Query Params:", queryParams);

      const reqQueryString = Object.entries(queryParams)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      // const reqQueryString = `job_title=${searchData?.job_title}&location=${searchData?.location}&requirement_type=${searchData?.requirement_type}$end_date=${searchData?.end_date}$start_date=${searchData?.start_date}`;

      console.log("Final Query String:", reqQueryString);

      dispatch(getJobTimeline(reqQueryString));
    } else {
      dispatch(getJobTimeline(""));
    }
    // }, [searchData, dispatch]);
  };

  const handleOnClear = () => {
    setSearchData({
      requirement_type: [],
      visa: [],
      location: [],
      start_date: "",
      end_date: "",
      job_title: [],
    });
    dispatch(getJobTimeline(""));
  };

  const getPreferSkillsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          skillData?.locations?.find((location) => location.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getPreferLocationsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  return (
    <Box className={styles.candidate_structure}>
      <Box
        className={styles.candidate_listing_text}
        sx={{ marginBottom: "14px" }}
      >
        <Typography sx={{ color: "customTextColor" }}>
          <b>Hot Openings</b>
        </Typography>
      </Box>

      <SearchRequirement
        handleOnClear={handleOnClear}
        jobTitles={jobTitles}
        setSearchData={setSearchData}
        searchData={searchData}
        handleOnClickSearch={handleOnClickSearch}
      />

      {jobtimelineStatus === "loading" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 230,
          }}
        >
          <CircularProgress size={30} color="info" />
        </Box>
      ) : (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{ padding: "15px 0 0 0" }}
          >
            {jobTimeline?.length > 0 ? (
              jobTimeline?.map((jobdata) => {
                return (
                  <TimelineCard
                    name={jobdata?.job_title}
                    mode={convertArrayToString(jobdata?.requirement_type)}
                    client={getPreferLocationsNames(jobdata?.location)}
                    salary={jobdata?.rate}
                    skills={
                      (jobdata?.skills !== undefined &&
                        jobdata?.skills !== null &&
                        jobdata?.skills !== "" &&
                        getPreferSkillsNames(jobdata?.skills)) ||
                      []
                    }
                    btn1="View & Apply"
                    btn2="Ask More"
                    matches={jobdata?.created_at}
                    posted={jobdata?.posted_by}
                    jobdata={jobdata}
                    handleShow={handleShow}
                    setHotListRow={setHotListRow}
                  />
                );
              })
            ) : (
              <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                No Hot Openings Found
              </h5>
            )}
          </Grid>
          <Box
            sx={{
              textAlign: "right",
              marginTop: "20px",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Pagination
              count={pagination.total_pages}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        </>
      )}
      <HotOpningViewDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        jobdata={hotListRow}
      />
    </Box>
  );
};

export default JobSearchResult;
